// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.window-frame {
  position: absolute;
  top: 0px;
  left: 0px;

  border: solid 2px #000;
  background: #fff;

  transform: translate(0px, 0px);

  z-index: 1;
}

.window-frame.window-is-top {
  box-shadow: 4px 4px 0px 0px #000;
}

.window-frame .frame-title-bar {
  position: relative;
  height: 36px;
  background: #fff;

  padding-bottom: 2px;
  margin-bottom: -2px;

  background-image: url('/assets/os6-window-bar.svg');
  background-size: auto;
  background-repeat: repeat-x;
  background-position: top left;
}

.window-frame .frame-title-bar .title-bar-button {
  width: 22px;
  height: 22px;

  background: #fff;
  border: solid 2px #000;
  box-shadow: 0px 0px 0px 2px #fff;

  font-size: 20px;
  text-align: center;
  line-height: 18px;

  z-index: 1;
}

.window-frame .frame-title-bar .title-bar-button.button-close > span {
  visibility: hidden;
}

.window-frame .frame-title-bar .title-bar-button.button-close:hover > span,
.window-frame .frame-title-bar .title-bar-button.button-close:active > span {
  visibility: visible;
}

.window-frame .frame-title-bar .title-bar-button:active {
  background-color: #000;
  color: #fff;
  border-color: #fff;
}

.window-frame .frame-title-bar .title-bar-spacer {
  width: 22px;
}

.window-frame .frame-title-bar .title-bar-title {
  background: #fff;
  padding: 2px 10px;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  pointer-events: none;

  z-index: 1;
}

.window-frame .frame-content-container {
  position: relative;

  margin-top: 2px;

  max-width: 100vw;
  max-height: 100vh;

  /* hack to make content expand properly */
  width: 0px;
  height: 0px;

  overflow: hidden;
  overflow-y: scroll;

  resize: both;
}

.window-frame .frame-content-container > .frame-content {
  position: relative;
  width: 100%;
  height: 100%;
}

.window-frame .input-catch {
  position: absolute;
  top: 36px;
  left: 0px;
  bottom: 0px;
  right: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/component/window-frame.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;;EAET,sBAAsB;EACtB,gBAAgB;;EAEhB,8BAA8B;;EAE9B,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;;EAEhB,mBAAmB;EACnB,mBAAmB;;EAEnB,mDAAmD;EACnD,qBAAqB;EACrB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;;EAEhC,eAAe;EACf,kBAAkB;EAClB,iBAAiB;;EAEjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;;EAEhB,oBAAoB;;EAEpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;;EAElB,eAAe;;EAEf,gBAAgB;EAChB,iBAAiB;;EAEjB,yCAAyC;EACzC,UAAU;EACV,WAAW;;EAEX,gBAAgB;EAChB,kBAAkB;;EAElB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,UAAU;AACZ","sourcesContent":[".window-frame {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n\n  border: solid 2px #000;\n  background: #fff;\n\n  transform: translate(0px, 0px);\n\n  z-index: 1;\n}\n\n.window-frame.window-is-top {\n  box-shadow: 4px 4px 0px 0px #000;\n}\n\n.window-frame .frame-title-bar {\n  position: relative;\n  height: 36px;\n  background: #fff;\n\n  padding-bottom: 2px;\n  margin-bottom: -2px;\n\n  background-image: url('/assets/os6-window-bar.svg');\n  background-size: auto;\n  background-repeat: repeat-x;\n  background-position: top left;\n}\n\n.window-frame .frame-title-bar .title-bar-button {\n  width: 22px;\n  height: 22px;\n\n  background: #fff;\n  border: solid 2px #000;\n  box-shadow: 0px 0px 0px 2px #fff;\n\n  font-size: 20px;\n  text-align: center;\n  line-height: 18px;\n\n  z-index: 1;\n}\n\n.window-frame .frame-title-bar .title-bar-button.button-close > span {\n  visibility: hidden;\n}\n\n.window-frame .frame-title-bar .title-bar-button.button-close:hover > span,\n.window-frame .frame-title-bar .title-bar-button.button-close:active > span {\n  visibility: visible;\n}\n\n.window-frame .frame-title-bar .title-bar-button:active {\n  background-color: #000;\n  color: #fff;\n  border-color: #fff;\n}\n\n.window-frame .frame-title-bar .title-bar-spacer {\n  width: 22px;\n}\n\n.window-frame .frame-title-bar .title-bar-title {\n  background: #fff;\n  padding: 2px 10px;\n\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n\n  pointer-events: none;\n\n  z-index: 1;\n}\n\n.window-frame .frame-content-container {\n  position: relative;\n\n  margin-top: 2px;\n\n  max-width: 100vw;\n  max-height: 100vh;\n\n  /* hack to make content expand properly */\n  width: 0px;\n  height: 0px;\n\n  overflow: hidden;\n  overflow-y: scroll;\n\n  resize: both;\n}\n\n.window-frame .frame-content-container > .frame-content {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.window-frame .input-catch {\n  position: absolute;\n  top: 36px;\n  left: 0px;\n  bottom: 0px;\n  right: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
